import { userTypes } from 'constants/user'

import * as actionTypes from '../actionTypes/User'

const initialState = {
    authenticated: false,
    type: userTypes.NONE,
    userInfo: {
        phone_number: null,
        full_name: null,
        avatar: '',
        user_id: '',
        gender: '',
    },
    tokens: {
        access_token: '',
        refresh_token: '',
    },
    qrcodeData: null,
}

export const setUserAuthenticated = (state, payload) => {
    return {
        ...state,
        authenticated: payload,
    }
}

export const setUserType = (state, payload) => {
    return {
        ...state,
        type: payload,
    }
}

export const setUserInfo = (state, payload) => {
    return {
        ...state,
        userInfo: {
            ...state.userInfo,
            ...payload,
        },
    }
}

export const setAuthTokens = (state, payload) => {
    return {
        ...state,
        tokens: payload,
    }
}

export const setMyUserAvatar = (state, payload) => {
    return {
        ...state,
        userInfo: {
            ...state.userInfo,
            avatar: payload,
        },
    }
}

export const setQRCodeData = (state, payload) => {
    return {
        ...state,
        qrcodeData: payload,
    }
}

const resetState = () => initialState

const userAuthenticationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_USER_AUTH_TOKENS:
            return setAuthTokens(state, action.payload)
        case actionTypes.SET_USER_INFO:
            return setUserInfo(state, action.payload)
        case actionTypes.SET_USER_AUTENTICATED:
            return setUserAuthenticated(state, action.payload)
        case actionTypes.SET_USER_TYPE:
            return setUserType(state, action.payload)
        case actionTypes.PERFORM_LOGOUT:
            return resetState()
        case actionTypes.RESET_SCHEDULE:
            return resetState()
        case actionTypes.SET_MY_AVATAR:
            return setMyUserAvatar(state, action.payload)
        case actionTypes.SET_QR_CODE_DATA:
            return setQRCodeData(state, action.data)
        default:
            return state
    }
}
export default userAuthenticationReducer
